import React from "react";
import "./GraphSection.css";

const GraphSection = () => {
  return (
    <section className="graph-section">
      <div className="graph-content">
        <h2 className="graph-title">Graphical Analysis: Emotion Correlations</h2>
        <p className="graph-description">
          The graphs below demonstrate the relationship between human emotions
          (Face Emotion Recognition - FER) and plant voltage signals (Plant
          Spiker Box - PSB), showcasing correlations for anger and joy.
        </p>

        <div className="graph-item">
          <img
            src="Graphs/Correlations FER (Face Emotion Recognition) PSB (Plant Spiker Box).jpg"
            alt="Correlations between FER and PSB"
            className="graph-image"
          />
          <p className="graph-caption">
            **Graph 1**: Pearson Correlation highlights that joy detected via
            plant signals (PSB) has a significant positive correlation, whereas
            anger shows a negative correlation.
          </p>
        </div>

        <div className="graph-item">
          <img
            src="Graphs/Comparing anger through FER and joy through PSB.jpg"
            alt="Comparing Anger and Joy"
            className="graph-image"
          />
          <p className="graph-caption">
            **Graph 2**: The blue line represents anger (FER) with significant
            peaks, while the orange line (PSB) shows stable joy signals. The red
            line indicates the moving average for anger over time.
          </p>
        </div>
      </div>
    </section>
  );
};

export default GraphSection;
